import React from "react";
import { css } from "@emotion/react";
export const vville = "Marseille";
const rville = "à Marseille";
const rdepartement = "dans les Bouches du Rhône";
const rregion = "en Provence-Alpes-Côte d'Azur";
const rpermis = "permis de construire";
const Rpermis = "Permis de construire";
const vefa = "VEFA";
export const url = "https://architectes-interieur-marseille.com";
const renviron =
  "Nos prestations d'architecture d'intérieur sont réalisées à Marseille dans les communes limitrophes de Marseille, notamment Cassis, Aubagne, La Ciotat, Sausset-les-Pins, Allauch, Carry-le-Rouet, Carnoux-en-Provence, Les Pennes-Mirabeau, etc.<br />Nous intervenons aussi dans d’autres villes des Bouches-du-Rhône (13): Le Tholonet, Cabriès, Trets, Saint-Cannat, Puyricard, Eguilles, Martigues, Arles (liste non exhaustive), mais aussi dans le département du Vaucluse (84).";

export function variablesSubstitution(string) {
  return string
    .replace(/rville/g, rville)
    .replace(/vville/g, vville)
    .replace(/rdepartement/g, rdepartement)
    .replace(/rregion/g, rregion)
    .replace(/rpermis/g, rpermis)
    .replace(/Rpermis/g, Rpermis)
    .replace(/VEFA/g, vefa)
    .replace(/renviron/g, renviron);
}

export class VilleLogo extends React.Component {
  render() {
    return (
      <div
        css={css`
          text-align: right;
          margin-right: 2px;
          font-size: 14px;
          line-height: 10px;
          bottom: 4px;
          right: 0;
          @media (max-width: 800px) {
            font-size: 12px;
            bottom: 6px;
          }
          @media (max-width: 600px) {
            font-size: 12px;
            bottom: 9px;
          }
        `}
      >
        Marseille
      </div>
    );
  }
}

export class Ville extends React.Component {
  render() {
    return <span>Marseille</span>;
  }
}

export class Rville extends React.Component {
  render() {
    return <span>à Marseille</span>;
  }
}

export class Rdepartement extends React.Component {
  render() {
    return <span>dans les Bouches du Rhône</span>;
  }
}

export class Rregion extends React.Component {
  render() {
    return <span>en Provence-Alpes-Côte d'Azur</span>;
  }
}

// Variables Banner

export const slider_ai_paris =
  "Rénovation d'un appartement haussmannien à Paris par un architecte d'intérieur";
export const slider_di_paris =
  "Aménagement d'un appartement haussmannien par un décorateur d'intérieur à Paris";
export const slider_a_paris =
  "Extension d'une maison ancienne réalisée par un architecte en Ile-de-France";
export const slider_ac_paris =
  "Aménagement d'un restaurant par un architecte spécialiste de l'architecture commerciale en région parisienne";
export const slider_jp_paris =
  "Aménagement paysager de la terrasse d'un appartement à Paris";

export const slider_mobile_ai_paris =
  "Aménagement d'un appartement haussmannien par un architecte d'intérieur basé à Paris";
export const slider_mobile_di_paris =
  "Décoration d'intérieur d'un appartement typiquement parisien";
export const slider_mobile_a_paris =
  "Extension d'une maison en Meulière réalisée par un architecte";
export const slider_mobile_ac_paris =
  "Un architecte aménage un restaurant à Paris";
export const slider_mobile_jp_paris =
  "Terrasse aménagée par un jardinier-paysagiste à Paris";

export const slider_ai_annecy =
  "Rénovation d'une maison à Annecy par un architecte d'intérieur";
export const slider_di_annecy =
  "Décoration d'intérieur d'une maison contemporaine dans la banlieue de Genève";
export const slider_a_annecy =
  "Maison contemporaine bois et beton réalisé par un architecte en Haute-Savoie (74)";
export const slider_ac_annecy =
  "Réalisation d'architecture commerciale à Aix-les-Bains";
export const slider_jp_annecy =
  "Jardin avec piscine aménagée par un architecte-paysagiste à Annecy";

export const slider_mobile_ai_annecy =
  "Cuisine ouverte contemporaine aménagé par un architecte d'intérieur à Annecy";
export const slider_mobile_di_annecy =
  "Décoration d'intérieur d'un appartement à Genève";
export const slider_mobile_a_annecy =
  "Maison contemporaine réalisé par un architecte à la frontière suisse";
export const slider_mobile_ac_annecy =
  "Aménagement intérieur d'un restaurant dans le centre historique d'Annecy";
export const slider_mobile_jp_annecy =
  "Terrasse aménagé par un paysagiste en Haute-Savoie (74)";

export const slider_ai_aix =
  "Rénovation complète d'un appartement typique d'Aix-en-Provence par un architecte d'intérieur";
export const slider_di_aix =
  "Rénovation d'un appartement ancien à Aix-en-Provence par un architecte d'intérieur";
export const slider_a_aix =
  "Rénovation d'un mas provencal avec piscine par un architecte d'Aix-en-Provence";
export const slider_ac_aix =
  "Aménagement d'un restaurant par un architecte à Aix-en-Provence";
export const slider_jp_aix =
  "Aménagement paysager de la terrasse d'un mas dans le Luberon";

export const slider_mobile_ai_aix =
  "Aménagement d'une villa contemporaine à Aix-en-Provence par un architecte d'intérieur";
export const slider_mobile_di_aix =
  "Décoration intérieur d'un appartement à Aix-en-Provence";
export const slider_mobile_a_aix =
  "Construction d'une villa contemporaine en Provence par un architecte";
export const slider_mobile_ac_aix =
  "Agencement d'un restaurant à Aix-en-Provence par un architecte";
export const slider_mobile_jp_aix =
  "Aménagement paysager d'un jardin provencal par un architecte paysagiste";

export const slider_ai_biarritz =
  "Aménagement intérieur d'une villa moderne à proximité de Biarritz";
export const slider_di_biarritz =
  "Rénovation complète d'un appartement art déco à Biarritz";
export const slider_a_biarritz =
  "Construction d'une maison d'architecte dans le Pays-Basque";
export const slider_ac_biarritz =
  "Aménagement d'un restaurant à Biarritz par un architecte";
export const slider_jp_biarritz =
  "Aménagement du jardin d'une maison basque typique par un paysagiste";

export const slider_mobile_ai_biarritz =
  "Rénovation intérieur d'un appartement à Biarritz par un architecte d'intérieur";
export const slider_mobile_di_biarritz =
  "Décoration intérieur d'un appartement contemporain à Biarritz";
export const slider_mobile_a_biarritz =
  "Extension d'une maison en pierre réalisé par un architecte du Pays Basque";
export const slider_mobile_ac_biarritz =
  "Aménagement d'un restaurant gastronomique par un architecte spécialiste de l'architecture commerciale";
export const slider_mobile_jp_biarritz =
  "Jardin d'une maison basque moderne aménagé par un paysagiste à Biarritz";

export const slider_ai_bordeaux =
  "Un architecte d'intérieur rénove entièrement une maison à Bordeaux";
export const slider_di_bordeaux =
  "Rénovation d'un appartement dans un immeuble ancien de Bordeaux";
export const slider_a_bordeaux =
  "Construction d'une maison d'architecte en Gironde";
export const slider_ac_bordeaux =
  "Aménagement intérieur d'un restaurant par un architecte à Bordeaux";
export const slider_jp_bordeaux =
  "Aménagement paysager du jardin d'une villa dans l'agglomération de Bordeaux";

export const slider_mobile_ai_bordeaux =
  "Aménagement d'une maison contemporaine par un architecte d'intérieur à Bordeaux";
export const slider_mobile_di_bordeaux =
  "Rénovation intérieure d'un appartement ancien à Bordeaux";
export const slider_mobile_a_bordeaux =
  "Maison contemporaine bois et béton conçue par un architecte à Bordeaux";
export const slider_mobile_ac_bordeaux =
  "Rénovation d'un restaurant par un architecte d'intérieur à Bordeaux";
export const slider_mobile_jp_bordeaux =
  "Jardin d'une maison de la région de Bordeaux aménagé par un architecte-paysagiste";

export const slider_ai_bruxelles =
  "Aménagement d'un appartement style loft par un architecte d'intérieur à Bruxelles";
export const slider_di_bruxelles =
  "Rénovation intérieure d'une maison ancienne à Bruxelles";
export const slider_a_bruxelles =
  "Rénovation d'une villa par un architecte dans la région de Bruxelles-Capital";
export const slider_ac_bruxelles =
  "Restaurant bistronomique à Bruxelles aménagé par un architecte d'intérieur";
export const slider_jp_bruxelles =
  "Terrasse d'un appartement bruxellois aménagé par un architecte-paysagiste";

export const slider_mobile_ai_bruxelles =
  "Rénovation d'une maison contemporaine par un architecte d'intérieur dans la région de Bruxelles-Capital";
export const slider_mobile_di_bruxelles =
  "Un décorateur d'intérieur aménage un appartement à Bruxelles";
export const slider_mobile_a_bruxelles =
  "Rénovation d'une maison bruxelloise par un archicte";
export const slider_mobile_ac_bruxelles =
  "Aménagement commerciale d'une restaurant par un architecte d'intérieur";
export const slider_mobile_jp_bruxelles =
  "Jardin d'une maison de ville à Bruxelles aménagé par un paysagiste";

export const slider_ai_lille =
  "Rénovation intérieure d'une maison ancienne dans la métropole lilloise";
export const slider_di_lille =
  "Rénovation et décoration intérieure d'une maison années 30 à proximité de Lille";
export const slider_a_lille =
  "Extension d'une maison en brique réalisée par un architecte dans la région de Lille";
export const slider_ac_lille =
  "Bar aménagé par un architecte spécialiste de l'architecture commerciale à Lille";
export const slider_jp_lille =
  "Petite terrasse d'un appartement de la région lilloise aménagée par un paysagiste";

export const slider_mobile_ai_lille =
  "Rénovation d'une maison année 30 par un architecte d'intérieur à Lille";
export const slider_mobile_di_lille =
  "Un architecte d'intérieur rénove entièrement un appartement du vieux Lille";
export const slider_mobile_a_lille =
  "Extension d'une maison ancienne dans la région de Lille";
export const slider_mobile_ac_lille =
  "Restaurant bistronomique à Lille aménagé par un architecte";
export const slider_mobile_jp_lille =
  "Jardin d'une maison de ville aménagé par un paysagiste de la région lilloise";

export const slider_ai_lyon =
  "Rénovation d'un appartement à Lyon par un architecte d'intérieur";
export const slider_di_lyon =
  "Un décorateur d'intérieur aménage un appartement à Lyon";
export const slider_a_lyon =
  "Extension d'une maison ancienne de la région lyonnaise par un architecte";
export const slider_ac_lyon = "Restaurant à Lyon aménagé par un architecte";
export const slider_jp_lyon =
  "Terrasse d'un appartement à Lyon aménagé par un architecte-paysagiste";

export const slider_mobile_ai_lyon =
  "Appartement ancien à lyon rénové par un architecte d'intérieur";
export const slider_mobile_di_lyon =
  "Rénovation d'un appartement canut à Lyon par un architecte d'intérieur";
export const slider_mobile_a_lyon =
  "Construction d'une maison d'architecte à Lyon";
export const slider_mobile_ac_lyon =
  "Un architecte spécialiste de l'architecture commerciale rénove un restaurant à Lyon";
export const slider_mobile_jp_lyon =
  "Terrasse d'un appartement situé dans un immeuble des années 70 aménagé par un paysagiste";

export const slider_ai_marseille =
  "Cuisine ouverte dans une villa aménagé par un architecte d'intérieur à Marseille";
export const slider_di_marseille =
  "Salon d'une maison ancienne à Marseille rénovée par un décorateur d'intérieur";
export const slider_a_marseille =
  "Extension d'une maison conçue par un architecte de la région de Marseille";
export const slider_ac_marseille =
  "Restaurant bistronomique aménagé par un spécialiste de l'architecture commerciale à Marseille";
export const slider_jp_marseille =
  "Jardin méditerranéen aménagé par un jardinier-paysagiste";

export const slider_mobile_ai_marseille =
  "Cuisine aménagé par un architecte d'intérieur à Marseille";
export const slider_mobile_di_marseille =
  "Décoration intérieure d'un appartement ancien à Marseille";
export const slider_mobile_a_marseille =
  "Maison contemporaine avec piscine dans les Bouches-du-Rhône";
export const slider_mobile_ac_marseille =
  "Restaurant après travaux de rénovation par un architecte d'intérieur";
export const slider_mobile_jp_marseille =
  "Un architecte-paysagiste aménage un jardin méditerranéen dans la région de Marseille";

export const slider_ai_montpellier =
  "Rénovation d'un appartement des années 70 à Montpellier par un architecte d'intérieur";
export const slider_di_montpellier =
  "Amenagement d'un appartement ancien avec cuisine ouverte par un décorateur d'intérieur ";
export const slider_a_montpellier =
  "Construction d'une villa contemporaine dans l'agglomération de Montpellier par un architecte";
export const slider_ac_montpellier =
  "Aménagement de locaux commerciaux par un architecte à Montpellier";
export const slider_jp_montpellier =
  "Terrasse méridionale aménagée par un architecte-paysagiste à Montpellier";

export const slider_mobile_ai_montpellier =
  "Rénovation de la cuisine d'un appartement ancien par un architecte d'intérieur à Montpellier";
export const slider_mobile_di_montpellier =
  "Décoration d'intérieur d'une villa contemporaine de l'Hérault par architecte d'intérieur";
export const slider_mobile_a_montpellier =
  "Maison d'architecte bois et béton par un architecte de la région de Montpellier";
export const slider_mobile_ac_montpellier =
  "Restaurant aménagé et décoré par un architecte spécialiste de l'architecture commerciale";
export const slider_mobile_jp_montpellier =
  "Terrasse en bois aménagé par un jardinier-paysagiste à Montpellier";

export const slider_ai_nantes =
  "Salon avec cuisine ouverte aménagé par un architecte d'intérieur à Nantes";
export const slider_di_nantes =
  "Décoration d'intérieur d'un appartement ancien à Nantes";
export const slider_a_nantes =
  "Extension moderne d'une maison ancienne à Nantes réalisée par un architecte";
export const slider_ac_nantes =
  "Restaurant aménagé par un architecte en Loire-Atlantique (44)";
export const slider_jp_nantes =
  "Aménagement paysager d'une maison d'architecte par un paysagiste basé dans l'agglomération de Nantes";

export const slider_mobile_ai_nantes =
  "Piece de vie moderne d'un appartement aménagé par un architecte d'intérieur à Nantes";
export const slider_mobile_di_nantes =
  "Salon d'un appartement ancien décoré par un décorateur d'intérieur nantais";
export const slider_mobile_a_nantes =
  "Conception d'une maison d'architecte en bois en Loire-Atlantique (44)";
export const slider_mobile_ac_nantes =
  "Un architecte aménage un restaurant bistronomique à Nantes";
export const slider_mobile_jp_nantes =
  "Terrasse paysagère d'une maison de ville à Nantes aménagé par un architecte-paysagiste";

export const slider_ai_nimes =
  "Cuisine ouverte sur une terrasse aménagée par un architecte d'intérieur à Nîmes";
export const slider_di_nimes =
  "Décoration d'intérieur d'un appartement ancien à Nîmes";
export const slider_a_nimes =
  "Rénovation d'une maison ancienne dans le Vaucluse par un architecte ";
export const slider_ac_nimes =
  "Restaurant rénové par un architecte spécialiste de l'architecture commerciale dans le Gard (30)";
export const slider_jp_nimes =
  "Terrasse d'une maison ancienne en pierre aménagée par un paysagiste de la région de Nîmes";

export const slider_mobile_ai_nimes =
  "Aménagement d'un salon duplex par un architecte d'intérieur à Nîmes";
export const slider_mobile_di_nimes =
  "Un décorateur d'intérieur aménage le salon d'un appartement ancien à Nîmes";
export const slider_mobile_a_nimes =
  "Construction d'une villa contemporaine par un architecte dans le Gard";
export const slider_mobile_ac_nimes =
  "Rénovation complète d'un restaurant par un architecte nîmois";
export const slider_mobile_jp_nimes =
  "Jardin provençale aménagé par un architecte-paysagiste dans le Vaucluse";

export const slider_ai_quimper =
  "Rénovation complète d'une maison bretonnne par un architecte d'intérieur à Quimper";
export const slider_di_quimper =
  "Décoration d'intérieur d'une maison de pêcheur en Bretagne";
export const slider_a_quimper =
  "Extension d'une maison bretonne ancienne par un architecte basé à Quimper";
export const slider_ac_quimper =
  "Restaurant de la côte bretonne aménagé par un architecte";
export const slider_jp_quimper =
  "Aménagement du jardin d'une maison en Bretagne par un paysagiste";

export const slider_mobile_ai_quimper =
  "Cusine aménagé par un architecte d'intérieur en Bretagne";
export const slider_mobile_di_quimper =
  "Rénovation du salon d'une maison à Quimper";
export const slider_mobile_a_quimper =
  "Extension d'une maison bretonne réalisée par un architecte";
export const slider_mobile_ac_quimper =
  "Restaurant rénové entièrement par un architecte spécialiste de l'architecture commerciale";
export const slider_mobile_jp_quimper =
  "Aménagement paysager en Bretagne réalisé par un architecte-paysagiste";

export const slider_ai_toulon =
  "Rénovation d'une cuisine par un architecte d'intérieur dans le Var";
export const slider_di_toulon =
  "Décoration d'intérieur d'une villa de la Côte d'Azur";
export const slider_a_toulon =
  "Villa contemporaine conçu par un architecte basé à Toulon";
export const slider_ac_toulon =
  "Restaurant de la Côte d'Azur aménagé par un architecte";
export const slider_jp_toulon =
  "jardin méditerranéen avec piscine aménagé par un jardinier-paysagiste";

export const slider_mobile_ai_toulon =
  "Aménagement intérieur d'une villa de la Côte d'Azur par un architecte d'intérieur";
export const slider_mobile_di_toulon =
  "Un décorateur d'intérieur rénove un appartement ancien à Toulon";
export const slider_mobile_a_toulon = "Maison d'architecte sur la Côte d'Azur";
export const slider_mobile_ac_toulon =
  "Rénovation d'un restaurant par un architecte spécialiste de l'architecture commerciale et tertaire dans le Var 83";
export const slider_mobile_jp_toulon =
  "Un architecte-paysagiste aménage un jardin méditerranéen avec une piscine sur la Côte d'Azur";

export const slider_ai_toulouse =
  "Rénovation d'un appartement du centre ville de Toulouse par un architecte d'intérieur";
export const slider_di_toulouse =
  "Décoration d'intérieur du salon d'un appartement à Toulouse";
export const slider_a_toulouse =
  "Villa contemporaine éco-responsable conçue par un architecte à Toulouse";
export const slider_ac_toulouse =
  "Aménagement intérieur d'un restaurant par un architecte d'intérieur";
export const slider_jp_toulouse =
  "Un paysagiste aménage la terrasse d'un appartement contemporain à Toulouse";

export const slider_mobile_ai_toulouse =
  "Aménagement d'une cuisine américaine par un architecte d'intérieur à Toulouse";
export const slider_mobile_di_toulouse =
  "Un décorateur d'intérieur renove le salon d'un appartement ancien à Toulouse";
export const slider_mobile_a_toulouse =
  "Construction de l'extension d'une maison ancienne à Toulouse";
export const slider_mobile_ac_toulouse =
  "Rénovation d'un bar - restaurant à Toulouse par un architecte";
export const slider_mobile_jp_toulouse =
  "Terrasse aménagée par un architecte-paysagiste à Toulouse";

export const slider_ai_tours =
  "Rénovation d'une grange par un architecte d'intérieur en Touraine";
export const slider_di_tours =
  "Décoration d'un salon par un décorateur professionnel exerçant à Tours";
export const slider_a_tours =
  "Rénovation complète d'un corps de ferme par un architecte en Touraine ";
export const slider_ac_tours =
  "Aménagement d'un bar à Tours par un architecte d'intérieur";
export const slider_jp_tours =
  "Jardin avec piscine et terrasse aménagé par un paysagiste à proximité de Tours";

export const slider_mobile_ai_tours =
  "Aménagement d'une maison contemporaine par un architecte d'intérieur à Tours";
export const slider_mobile_di_tours =
  "Décoration d'intérieur d'un appartement du centre ville de Tours";
export const slider_mobile_a_tours =
  "Rénovation complète d'une grange en Touraine par un architecte";
export const slider_mobile_ac_tours =
  "Un architecte spécialiste de l'architecture commerciale aménage un restaurant/bar dans l'Indre-et-Loire 37";
export const slider_mobile_jp_tours =
  "Terrasse d'un corps de ferme aménagée par un paysagiste en Touraine";
